import TMAlert from '@/tools/models/TMAlert';
import User from '@/tools/models/User';

export default class RootState {
  public alert = new TMAlert();

  public user = new User();

  public intialMessageShown = false;
}
